var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriceceilingsimage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 876.25 232.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #006d7f;\n      }\n\n      .cls-2 {\n        fill: #043e4b;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: #a3cfd9;\n        opacity: .91;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 94.19,
    y: 0.2,
    width: 686.43,
    height: 192.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 432.4,
    y: -259.97,
    width: 10,
    height: 712.85,
    transform: "translate(231.98 494.48) rotate(-75.14)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 81.72,
    y: 91.62,
    width: 712.93,
    height: 10.07,
    transform: "translate(-10.11 116.18) rotate(-14.93)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m422.63,101.33h-12v-6h12v6Zm-24,0h-12v-6h12v6Zm-24,0h-12v-6h12v6Zm-24,0h-12v-6h12v6Zm-24,0h-12v-6h12v6Zm-24,0h-12v-6h12v6Zm-24,0h-12v-6h12v6Zm-24,0h-12v-6h12v6Zm-24,0h-12v-6h12v6Zm-24,0h-12v-6h12v6Zm-24,0h-12v-6h12v6Zm-24,0h-12v-6h12v6Zm-24,0h-12v-6h12v6Zm-24,0h-12v-6h12v6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m866.75,47.19H9.5c-5.25,0-9.5-4.25-9.5-9.5s4.25-9.5,9.5-9.5h857.25c5.25,0,9.5,4.25,9.5,9.5s-4.25,9.5-9.5,9.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 428.68,
    y: 132.94,
    width: 20,
    height: 100
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "487.55 147.24 438.68 62.61 389.82 147.24 487.55 147.24"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceceilingsimage);
export default __webpack_public_path__ + "static/media/Price ceilings image.3880d4c9cab2c68aa0a0dec113034551.svg";
export { ForwardRef as ReactComponent };